import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TopbarClient } from "./TopbarClient";
import styles from "./ClientLayout.module.css";
export const ClientLayout = ({ children }) => {
    return (_jsxs("div", { className: styles.container, children: [_jsx(TopbarClient, {}), _jsx("main", { className: styles.mainContent, children: children })] }));
};
